import React from "react";
import iconPlay from "../../assets/icon/ic_play_lg.svg";
import styled from "styled-components";

const StyledPlayButton = styled.div`
    cursor: pointer;
    display: inline-block;
    width: 113px;
    height: 113px;
    background-color: #5F5CFE;
    border-radius: 4px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    
    :hover {
        background-color: #3D39FF;
    }
`;

const PlayButtonLG: React.FC = (() => {
    return (
        <StyledPlayButton>
            <img src={iconPlay} alt=""/>
        </StyledPlayButton>
    )
});

export default PlayButtonLG;